import { Component } from "@angular/core";

@Component({
	templateUrl: "./translation.component.html"
})
export class TranslationComponent { }
